import { Icon } from '@iconify/react';
import { useDirection } from '../../contexts/DirectionContext';

interface CheckboxProps {
  checked: boolean;
  label?: string;
  count?: number;
  onClick?: () => void;
  truncate?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  label,
  count,
  onClick,
  truncate = true
}) => {
  const { isRTL } = useDirection();

  return (
    <button
      onClick={onClick}
      className={`group w-full px-3 py-1 flex items-start text-sm transition-colors hover:bg-surface-secondary/50 rounded-md ${isRTL ? 'flex-row-reverse' : ''}`}
    >
      <div className="flex items-start min-w-0 flex-1">
        <div className={`
          w-4 h-4 rounded-[4px] border transition-colors flex items-center justify-center flex-shrink-0 mt-0.5
          ${checked
            ? 'border-primary-500 bg-primary-500'
            : 'border-border-primary group-hover:border-primary-500/50'
          }
          ${isRTL ? 'ml-3' : 'mr-3'}
        `}>
          {checked && (
            <Icon icon="ph:check-bold" className="w-2.5 h-2.5 text-white" />
          )}
        </div>
        {label && <span className={`text-text-primary text-sm ${truncate ? 'truncate' : 'break-words whitespace-normal text-start'} ${isRTL ? 'text-right' : 'text-left'}`}>{label}</span>}
      </div>
    </button>
  );
}; 